import axios from "axios";
import { handleAxiosErrors } from "../utils";

const CREATE_PROSPECT = "/prospect/create-prospect";

export const createProspect = ({
  nom,
  prenom,
  nomEntreprise,
  civilite,
  email,
  telephoneFixe,
  telephoneMobile,
  marche,
  adresseCommune,
  adresseRue,
  adresseNum,
  imb,
  latitude,
  longitude,
  resultat,
  validRGPD,
}) =>
  axios
    .post(CREATE_PROSPECT, {
      nom,
      prenom,
      nomEntreprise,
      civilite,
      email,
      telephoneFixe,
      telephoneMobile,
      marche,
      adresseCommune,
      adresseRue,
      adresseNum,
      imb,
      latitude,
      longitude,
      resultat,
      validRGPD,
    })
    .then(response => handleAxiosErrors(response))
    .catch(error => Promise.reject(error));
